const SUPPORTED_MARKETS = ['es', 'pt'] as const
export type SupportedMarket = (typeof SUPPORTED_MARKETS)[number]

export const MEALS_LIMIT_EUR_SPAIN = 22000
export const TRANSPORTATION_LIMIT_EUR_SPAIN = 13636
